import { abyssColors } from '@/theme/colors';
import { Box, styled as muiStyled } from '@mui/material';

export const tabStyles = {
  width: 'fit-content',
  minHeight: 'fit-content',
  '& .MuiTabs-flexContainer': {
    width: 'fit-content',
    gap: '2.4rem',
  },
  '& .MuiTab-root': {
    width: 'auto',
    padding: '1.6rem 1rem',
    fontSize: '1.4rem',
    fontStyle: 'normal',
    letterSpacing: '0.014rem',
    fontWeight: 500,
    minWidth: 'fit-content',
    minHeight: 'fit-content',
    textTransform: 'none',
    lineHeight: '1.6rem',
    color: `${abyssColors.primary[400]} !important`,
    marginX: '0.8rem',
  },
  '& .MuiTab-root.Mui-selected': {
    color: `${abyssColors.primary[500]} !important`,
  },
  '& .MuiTab-textColorPrimary': {
    color: abyssColors.primary[400],
  },
  '& .MuiTabs-indicator': {
    backgroundColor: abyssColors.primary[500],
    height: '0.4rem',
    borderRadius: '0.8rem',
    zIndex: 2,
  },
};

export const FloatingLine = muiStyled(Box)(() => ({
  borderTop: `0.1rem solid ${abyssColors.primary[200]}`,
  width: '100%',
  position: 'relative',
  bottom: '0.3rem',
  zIndex: '1',
  opacity: 0.5,
}));

export const closeIconStyles = {
  fontSize: '2.4rem',
  color: abyssColors.primary[500],
};

export const dialogStyles = {
  '.MuiDialog-container': {
    alignItems: 'baseline',
    paddingTop: '0',
  },
};

export const paperStyles = {
  maxWidth: '52.8rem',
  height: '40rem',
};

export const titleStyles = {
  padding: '2.4rem',
  paddingBottom: '1rem',
  typography: 'h4',
};

export const actionsStyles = {
  borderTop: `0.1rem solid ${abyssColors.primary[100]}`,
  padding: '1.6rem 2.4rem 2rem 1.6rem',
  gap: '1.6rem',
  button: {
    margin: '0 !important',
  },
};
